import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../../Controls/Spinner';
import * as ResearchActionCreators from "../../../actions/research.actions";

export interface IResearchProps {
    research: CreDtos.Research[];
    isLoading: boolean;
    load: Function;
    edit: Function;
    add: Function;
    search: string;
    showDisabled: boolean;
    filter: Function;
}

interface IResearchState {
    search: string
}

class Research extends React.Component<IResearchProps, IResearchState> {
    constructor(props: IResearchProps) {
        super(props);
        this.props.load();
        // push to redux state
        this.state = {
            search: this.props.search
        }
        this.onSearch = this.onSearch.bind(this);
        this.onSearchChanged = this.onSearchChanged.bind(this);
        this.onShowDisabledChanged = this.onShowDisabledChanged.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    onSearchChanged(e) {
        this.setState({ search: e });
    }

    onSearch() {
        this.props.filter(this.state.search, this.props.showDisabled);
    }

    onShowDisabledChanged(e) {
        this.props.filter(this.props.search, !this.props.showDisabled);
    }

    onEdit(item: CreDtos.Research) {
        this.props.edit(item);
    }

    render() {
        let content;

        if (this.props.isLoading) {
            content = (
                <Spinner isOpen={this.props.isLoading} />
            );
        } else {
            let items;
            if (this.props.research.length > 0) {
                items = this.props.research.map((item, index) => {
                    let img = item.images;
                    if (!img || img.length == 0) {
                        img = "./images/Unconfirmed.png";
                    }
                    return (
                        <div className="row pt-2 pb-2" key={"research" + item.id}>
                            <div className={classNames("col col-8 col-lg-9", { "row-disabled-text": !item.enabled })}>{item.title}</div>
                            <div className="col col-2 col-lg-2">
                                <span>{item.sortOrder}</span>
                            </div>
                            <div className="col col-2 col-lg-1">
                                <div className="text-right mr-2" onClick={() => this.onEdit(item)}>
                                    <a><span className="fa fa-edit fa-lg"></span></a>
                                </div>
                            </div>
                        </div>
                    )
                })
            } else {
                items = (
                    <div className="alert alert-info text-center" role="alert">
                        No records found
                    </div>
                );
            }

            let search = (
                <div className="search input-group mb-2">
                    <input type="search" className="form-control lightgrey-bg"
                        placeholder="Search..."
                        defaultValue={this.state.search}
                        onChange={(e) => this.onSearchChanged(e.target.value)}
                        onBlur={() => this.onSearch()}
                    />
                    <button type="button" id="searchBtn" className="input-group-addon btn btn-white" onClick={() => this.onSearch()}>
                        <span className="fa fa-search"></span>
                    </button>
                </div>
            );

            let showDisabled = (
                <div className="search input-group mb-2">
                    <label>
                        <input type="checkbox" checked={this.props.showDisabled} onChange={e => this.onShowDisabledChanged(e)} /> Show disabled
                    </label>
                </div>
            )


            content = (
                <div className="row fixed-scrolling-side">
                    <div className="col-12 col-lg-3 pl-md-0 mb-3 discussion-board sidebar">
                        <div className="sidebar-actions">
                            <div className="row">
                                <div className="col-6">
                                    {search}
                                </div>
                                <div className="col-6">
                                    <button type="button" className="btn btn-default btn-block" onClick={() => this.props.add()}>Add Research</button>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className="sidebar-actions-lg">
                            {search}
                            {showDisabled}
                            <hr />
                            <button type="button" className="btn btn-default btn-block" onClick={() => this.props.add()}>Add Project</button>
                        </div>
                    </div>
                    <div className="col-12 col-lg-9">
                        <div className="discussion-board-resource">
                            <div className="row hide-xs hide-md">
                                <div className="col-8 col-lg-9">
                                    <strong>TITLE</strong>
                                </div>
                                <div className="col-2 col-lg-2">
                                    <strong>SORT</strong>
                                </div>
                                <div className="col-2 col-lg-1">
                                </div>
                            </div>
                            {items}
                        </div>
                    </div>
                </div>

            );
        }

        return (
            <div>
                {content}
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        isLoading: state.research.isLoading,
        research: state.research.filteredResearch,
        search: state.research.search,
        showDisabled: state.research.showDisabled
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            load: ResearchActionCreators.researchRequest,
            filter: ResearchActionCreators.researchFilter,
            edit: ResearchActionCreators.researchEdit,
            add: ResearchActionCreators.researchAdd
        },
        dispatch
    );
};


const ResearchContainer = connect(mapStateToProps, mapDispatchToProps)(
    Research
);

export default ResearchContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/Research/Research.tsx